import { useState } from 'react'
import { Banknote, ShoppingBasket, TrendingUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useKitchenFlowEnabled } from '@/hooks/useKitchenFlowEnabled'
import { OrderSuggestionsDialog } from './OrderSuggestionsDialog'
import { PriceAlertsDialog } from './PriceAlertsDialog'
import { PettyCashDialog } from './PettyCashDialog'
import { PURCHASING_STRINGS } from './purchasingStrings'

/** Kitchen flow lane D: the three purchasing shortcuts above the PO queue.
 *  Renders nothing unless the tenant has the kitchen flow. */
export function KitchenFlowPurchasingBar({ onOpenPo, showToast }: {
  onOpenPo: (id: string) => void
  showToast: (t: 'success' | 'error', m: string) => void
}) {
  const enabled = useKitchenFlowEnabled()
  const [open, setOpen] = useState<'suggestions' | 'prices' | 'petty' | null>(null)
  if (!enabled) return null
  const S = PURCHASING_STRINGS
  const close = () => setOpen(null)
  return (
    <>
      <div className="mb-4 flex flex-wrap gap-2">
        <Button onClick={() => setOpen('suggestions')}>
          <ShoppingBasket className="mr-2 h-4 w-4" /> {S.suggestions.open}
        </Button>
        <Button variant="outline" onClick={() => setOpen('prices')}>
          <TrendingUp className="mr-2 h-4 w-4" /> {S.priceAlerts.open}
        </Button>
        <Button variant="outline" onClick={() => setOpen('petty')}>
          <Banknote className="mr-2 h-4 w-4" /> {S.pettyCash.open}
        </Button>
      </div>
      <OrderSuggestionsDialog open={open === 'suggestions'} onClose={close} onOpenPo={onOpenPo} showToast={showToast} />
      <PriceAlertsDialog open={open === 'prices'} onClose={close} />
      <PettyCashDialog open={open === 'petty'} onClose={close} onOpenPo={onOpenPo} />
    </>
  )
}
